module.exports = __webpack_public_path__ + "static/pro-banner10@2x-0603243aa1176f7b0bc54b91cb9a5ef9.jpg";